import React from "react"
import styled from "styled-components"
import { Input } from "antd"
import { getColor } from "../../../../components/Color"
import { media } from "../../../../components/mediaStylesNew"

const TextInput = styled(Input.TextArea)`
  max-width: 100%;
  font-family: GT America, sans-serif;
  padding-right: 30px !important;
  font-size: 16px !important;

  &:focus,
  &:hover {
    border-color: ${getColor("primary", 0.6)} !important;
    box-shadow: none;
  }

  ${media.largerPhone`
  max-width: 300px;
`}
`

const AreaWrapper = styled.div`
  position: relative;
`

const Prefix = styled.div`
  position: absolute;
  top: -5px;
  right: 10px;
  z-index: 1;
`

const Suffix = styled.div`
  position: absolute;
  bottom: 0px;
  right: 10px;
  z-index: 1;
`

export default props => {
  return (
    <AreaWrapper>
      <Prefix>{props.prefix}</Prefix>
      <TextInput
        {...props}
        rows={4}
        onPressEnter={event => {
          event.stopPropagation()
        }}
      />
      <Suffix>{props.suffix}</Suffix>
    </AreaWrapper>
  )
}
